import { Box, Container, Grid } from '@mui/material';
import { Button, Col, Row } from 'react-bootstrap'
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from 'react'
import '../../assets/airlines/airlineLogoSprites.css';
import flightImg from '../../assets/images/spicejet.png'
import './specialoffer.css'
import '../../pages/flights/flight-results/oneWayResults.css';
import arrowFlight from '../../assets/images/arrowflight.png';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
import { getAuth } from '../../utility/apiConfig';
import { API_BASE_URL } from '../../utility/apiConstants';
import moment from 'moment';
import SpecialOfferSkltn from './SpecialOfferSkltn';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: 15
  },
})

const SpecialOffer = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [inventoryList, setInventoryList] = useState(null);

    useEffect(() => {
       getInventoryList();
      }, [])

      const getInventoryList = () => {
        try {
            setIsLoading(true);
            getAuth(API_BASE_URL + 'data/get_inventory_list')
              .then((response) => {
                const data = response.data.data;
                setInventoryList(data);
                setIsLoading(false);
              })
              .catch((error) => {
                setIsLoading(false);
              })
          } catch (error) {
            setIsLoading(false);
          }
      }
  return (
        <Container className="special-offer">
              <Box className="special-offer-box">
                <Row>
                    <Col md={12}>
                    </Col>

                    <Col xs={12} md={6}>
                        <h4 className="specailfarelabel">Scan & Pay</h4>    
                        <Box className="special-offer-left">
                            <Box className='offer-bg-img'>
                            <Box className='special-offer-button'>
                                <a href="/top-up-recharge" className='special-offer-link'>Top up balance</a>
                            </Box>
                            </Box>
                        </Box>
                    </Col>

                    <Col xs={12} md={6}>
                        <h4 className="specailfarelabel">Flight Special Fares</h4>    

                        {!isLoading ? (
                        <Box className='special-offer-right'>
                            {inventoryList && inventoryList.length > 0 && inventoryList.map((item, index) => {return (
                            <Row className="offer-flight-row">
                                <Col xs={3} md={2} className='m-auto'>
                                    <Box>
                                        <Box className={'itwgo-60x35_' + `${item.airline}`}></Box>
                                    </Box>
                                </Col>
                                <Col xs={9} md={6} className="px-0 m-auto">
                                    <Box className="flexset">
                                        <Box className="definewidth">
                                            <Box className="flightmininame">{item.source_loc}</Box>
                                        </Box>
                                        <Box className="arrowbox">
                                            <Box className="arrow-img"> <span className='arrow-line'></span><img src={arrowFlight}></img></Box>
                                
                                        </Box>
                                        <Box className="definewidth">
                                            <Box className="flightmininame">{item.destination_loc}</Box>
                                        </Box>
                                    </Box>
                                </Col>
                                <Col xs={12} md={4} className="text-right">
                                    <Box>
                                        <Box className='flightnameoffer'>{item.airline_name}</Box>

                                        <Box className='offerdate'><CalendarMonthIcon /> {moment(item.dept_date).format("MMM DD, YYYY")}</Box>
                                        <Box className="seats-count-home"><AirlineSeatReclineNormalIcon /> {item.seats_left} Seats</Box>
                                    </Box>
                                </Col>
                            </Row>
                           )})}
                            <p className="offer-bottom-p">And many more… Find more special fares on <a href='#'>See more</a> </p>
                        </Box>
                        ) : (
                            <SpecialOfferSkltn />
                        )}
                    </Col>
                </Row>
                
              </Box>
        </Container>
  )
}
export default SpecialOffer
